// extracted by mini-css-extract-plugin
module.exports = {"image":"CanvasPreviewImage_image__0Jhgp"};